export default __webpack_public_path__ + "static/media/Sound of Moosic.c70e0341.png";